import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import ExportXlsx from '../../../../utils/ExportXlsx';
import getCurrentDateWithHyphen from '../../../../utils/getCurrentDateWithHyphen';
import { WorkplaceFromApiObject } from '../../types';

interface UseDownloadExcelI {
  fullWorkplacesInfo: WorkplaceFromApiObject[]
}

export default function useDownloadExcel({ fullWorkplacesInfo }: UseDownloadExcelI) {
  const { companyName } = useGetGeneralAppData();

  function downloadExcel() {
    const mappedWorkplacesList = fullWorkplacesInfo.map((wp) => ({
      Denominação: wp.denominacaoLT,
      'Código no cliente': wp.codEndNoclienteAlfaN,
      // 'Código interno': wp.codEnd,
      Status: wp.endAtivo ? 'Ativo' : 'Inativo',
      CEP: wp.cep,
      Logradouro: wp.logradouro,
      Número: wp.numero,
      Complemento: wp.complemento,
      Bairro: wp.bairro,
      Cidade: wp.cidade,
      UF: wp.UF,
      'Sem Integra': wp.semIntegrarRJ ? 1 : 0,
      'Valor Teto': String(wp.valorTeto),
      Latitude: String(wp.lat)?.replaceAll('.', '_') || '',
      Longitude: String(wp.lng)?.replaceAll('.', '_') || '',
      'Utiliza Fretamento?': wp.temFretamento ? 'Sim' : 'Não',
      'Código OP Fretamento': wp.codFreta || '',
      'Usa VT + Fretamento?': !(wp.opcaoVTFreta) && wp.temFretamento ? 'Sim' : 'Não',
    }));
    const currentDate = getCurrentDateWithHyphen();
    ExportXlsx({
      filename: `Locais de trabalho ${companyName} - ${currentDate}`,
      data: mappedWorkplacesList,
    });
  }

  return { downloadExcel };
}
